(() => {
  const initRoot = (root) => {
    if (!root || root.dataset.ehInitialized === 'true') return;
    root.dataset.ehInitialized = 'true';

    const variantsData = root.querySelector('[data-product-variants]');
    if (!variantsData) return;

    const variants = JSON.parse(variantsData.textContent || '[]');
    const variantInput = root.querySelector('[data-variant-id-input]');
    const currentPriceEl = root.querySelector('[data-current-price-text]');
    const comparePriceEl = root.querySelector('[data-compare-price-text]');
    const savingEl = root.querySelector('[data-saving-text]');
    const stockRow = root.querySelector('[data-stock-row]');
    const stockLabel = root.querySelector('[data-stock-label]');
    const atcButton = root.querySelector('[data-atc-button]');
    const atcText = root.querySelector('[data-atc-text]');
    const galleryMainImage = root.querySelector('[data-gallery-main-image]');
    const galleryBadge = root.querySelector('[data-gallery-badge]');
    const thumbButtons = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const optionInputs = Array.from(root.querySelectorAll('[data-option-position]'));
    const scrollButton = root.querySelector('[data-scroll-description]');
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    const priceBox = root.querySelector('[data-price-box]');
    const qtyInput = root.querySelector('.eh-qty__input');
    const qtyMinus = root.querySelector('[data-qty-minus]');
    const qtyPlus = root.querySelector('[data-qty-plus]');
    const descriptionTarget = document.querySelector('[data-product-description-anchor]');
    const inStockText = stockRow?.dataset.inStockLabel || 'In stoc';
    const outOfStockText = stockRow?.dataset.outOfStockLabel || 'Stoc epuizat';
    const addToCartLabel = root.dataset.addToCartLabel || 'Adauga in cos';
    const soldOutLabel = root.dataset.soldOutLabel || 'Stoc epuizat';
    const stickyButtonLabel = root.dataset.stickyButtonLabel || addToCartLabel;

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      return `${new Intl.NumberFormat('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount)} lei`;
    };

    const getSelectedOptions = () => {
      const grouped = {};
      optionInputs.forEach((input) => {
        const position = input.dataset.optionPosition;
        if (!grouped[position]) grouped[position] = [];
        grouped[position].push(input);
      });

      return Object.keys(grouped)
        .sort((a, b) => Number(a) - Number(b))
        .map((position) => {
          const checked = grouped[position].find((input) => input.checked);
          return checked ? checked.value : grouped[position][0]?.value;
        });
    };

    const updatePrice = (variant) => {
      if (!currentPriceEl || !comparePriceEl || !savingEl) return;

      const current = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);

      currentPriceEl.textContent = formatMoney(current);

      if (compare > current) {
        comparePriceEl.textContent = formatMoney(compare);
        comparePriceEl.classList.remove('is-hidden');
        savingEl.textContent = `Economisesti ${formatMoney(compare - current)} · -${Math.round(((compare - current) / compare) * 100)}%`;
        savingEl.classList.remove('is-hidden');
      } else {
        comparePriceEl.classList.add('is-hidden');
        savingEl.classList.add('is-hidden');
      }
    };

    const updateStock = (variant) => {
      const isAvailable = !!variant.available;

      stockRow?.classList.toggle('is-soldout', !isAvailable);
      if (stockLabel) stockLabel.textContent = isAvailable ? inStockText : outOfStockText;
      if (atcButton) atcButton.disabled = !isAvailable;
      if (atcText) atcText.textContent = isAvailable ? addToCartLabel : soldOutLabel;
      if (stickySubmit) {
        stickySubmit.disabled = !isAvailable;
        stickySubmit.textContent = isAvailable ? stickyButtonLabel : soldOutLabel;
      }

      if (!galleryBadge) return;

      if (!isAvailable) {
        galleryBadge.textContent = 'Stoc epuizat';
        galleryBadge.classList.add('is-soldout');
        galleryBadge.classList.remove('is-hidden');
      } else if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
        galleryBadge.textContent = `-${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%`;
        galleryBadge.classList.remove('is-hidden', 'is-soldout');
      } else {
        galleryBadge.classList.add('is-hidden');
        galleryBadge.classList.remove('is-soldout');
      }
    };

    const updateGallery = (variant) => {
      if (!variant.featured_media || !galleryMainImage) return;

      const matched = thumbButtons.find((button) => Number(button.dataset.mediaId) === Number(variant.featured_media.id));
      if (!matched) return;

      thumbButtons.forEach((button) => button.classList.toggle('is-active', button === matched));
      galleryMainImage.src = matched.dataset.src;
      galleryMainImage.alt = matched.dataset.alt || variant.name || galleryMainImage.alt;
    };

    const findVariant = (selectedOptions) =>
      variants.find((variant) => selectedOptions.every((option, index) => variant.options[index] === option)) || variants[0];

    const setVariant = () => {
      const variant = findVariant(getSelectedOptions());
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceBox) {
        priceBox.dataset.currentPrice = variant.price;
        priceBox.dataset.comparePrice = variant.compare_at_price || 0;
      }

      updatePrice(variant);
      updateStock(variant);
      updateGallery(variant);
    };

    optionInputs.forEach((input) => input.addEventListener('change', setVariant));

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        thumbButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        if (galleryMainImage) {
          galleryMainImage.src = button.dataset.src;
          galleryMainImage.alt = button.dataset.alt || galleryMainImage.alt;
        }
      });
    });

    qtyMinus?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) - 1);
    });

    qtyPlus?.addEventListener('click', () => {
      qtyInput.value = (Number(qtyInput.value) || 1) + 1;
    });

    scrollButton?.addEventListener('click', () => {
      descriptionTarget?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    stickySubmit?.addEventListener('click', () => {
      atcButton?.click();
    });

    setVariant();
  };

  const init = (container = document) => {
    container.querySelectorAll('[data-eh-product-main]').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
